import { useState, useEffect } from 'react';
import axios from 'axios';
import { withOktaAuth } from '@okta/okta-react';

const TicketCounter = (props) => {
	let [counter, setCounter] = useState({
		new: 0,
		"worked in progress": 0,
		"resolved": 0,
		"additional information required": 0,
	});
	let [appLoading, setAppLoading] = useState(true);

	useEffect(() => {
		getStatusCount();
	}, [appLoading])


	let getStatusCount = () => {
		let token = localStorage.getItem('access-token');
		axios.get('/api/tickets/status-count', {
			params: {
				status: ['new', 'worked in progress', 'resolved', 'additional information required']
			},
			headers: {
				Authorization: `Bearer ${token}`
			}
		}).then(response => {
			let { data } = response.data;
			setCounter(data);
			setAppLoading(false)
		}).catch(err => {
			setAppLoading(false)
		})
	}

	return (

		<div className="row mt-5">
			<div className="col-3">
				<div className="card">
					<h5 className="card-header">New</h5>
					<div className="card-body">
						<h5 className="card-title text-center">
							{appLoading ?
								<div className="spinner-border" role="status">
									<span className="sr-only">Loading...</span>
								</div>
								: <>{counter.new}</>
							}
						</h5>
					</div>
				</div>
			</div>

			<div className="col-3">
				<div className="card">
					<h5 className="card-header">Worked In Progress</h5>
					<div className="card-body">
						<h5 className="card-title text-center">
							{appLoading ?
								<div className="spinner-border" role="status">
									<span className="sr-only">Loading...</span>
								</div>
								: <>{counter["worked in progress"]}</>
							}
						</h5>
					</div>
				</div>
			</div>

			<div className="col-3">
				<div className="card">
					<h5 className="card-header">Additional Information Required</h5>
					<div className="card-body">
						<h5 className="card-title text-center">
							{appLoading ?
								<div className="spinner-border" role="status">
									<span className="sr-only">Loading...</span>
								</div>
								: <>{counter['additional information required']}</>
							}
						</h5>
					</div>
				</div>
			</div>

			<div className="col-3">
				<div className="card">
					<h5 className="card-header">Resolved</h5>
					<div className="card-body">
						<h5 className="card-title text-center">
							{appLoading ?
								<div className="spinner-border" role="status">
									<span className="sr-only">Loading...</span>
								</div>
								: <>{counter['resolved']}</>
							}
						</h5>
					</div>
				</div>
			</div>

		</div>
	)
}

export default withOktaAuth(TicketCounter);